import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconHamburger = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 18,
	viewBox: "0 0 24 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0 1.125C0 0.515625 0.46875 0 1.125 0H19.875C20.4844 0 21 0.515625 21 1.125C21 1.78125 20.4844 2.25 19.875 2.25H1.125C0.46875 2.25 0 1.78125 0 1.125ZM3 8.625C3 8.01562 3.46875 7.5 4.125 7.5H22.875C23.4844 7.5 24 8.01562 24 8.625C24 9.28125 23.4844 9.75 22.875 9.75H4.125C3.46875 9.75 3 9.28125 3 8.625ZM21 16.125C21 16.7812 20.4844 17.25 19.875 17.25H1.125C0.46875 17.25 0 16.7812 0 16.125C0 15.5156 0.46875 15 1.125 15H19.875C20.4844 15 21 15.5156 21 16.125Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgIconHamburger);
export { ForwardRef as ReactComponent };
